var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 100",
    style: {
      enableBackground: "new 0 0 300 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 123.3703,
    cy: -224.8043,
    r: 107.1353,
    gradientTransform: "matrix(0.9954 0 0 1.0104 -11.4148 302.0881)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2816,
    style: {
      stopColor: "#E51300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#850C01"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.44,
    y: 67.5,
    className: "st0",
    width: 211.9,
    height: 14.91
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.06,88.38L256.41,88c-12.74-7.41-21.82-16.51-27.78-27.83c-5.48-10.42-8.41-22.99-8.95-38.44l-0.03-0.88 l0.81-0.35c13.86-6.06,24.46-8.53,36.58-8.53c0.01,0,0.02,0,0.03,0c12.11,0,22.72,2.48,36.6,8.53l0.81,0.35l-0.03,0.88 c-0.54,15.45-3.46,28.02-8.95,38.44c-5.96,11.32-15.05,20.42-27.78,27.83L257.06,88.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 257.4499,
    cy: -103.5265,
    r: 234.6279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#E51300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#850C01"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.28,27.8c-4.05-11.51,5.08-2.89,8.88-2.91c-2.49,1.42-6.85-2.88-8.65-2.13c2.35,0.72,3.07,3.43,4.16,3.7 c-3.4,1.61-5.21,3.82-6.19,7.67c0.55-1.39,1.37-2.66,2.74-3.5c-2.41,2.96-3.52,7.7-2.12,12.92 C241.69,38.51,243.15,31.2,246.28,27.8z M263.84,31.56c1.93,1.15,3.68,2.55,5.29,4.15l-1.07-1.79l0.41-1.55 C267.04,31.87,265.52,31.56,263.84,31.56z M244.98,20.71c-9.54,1.5-16.38,6.16-20.87,13.56c0.53,3.35,1.24,6.63,2.14,9.82 C228.11,33.03,234.09,25.04,244.98,20.71z M252.98,65.4c4.29,5.1,7.02,10.2,8.05,16.57c-1.27,0.85-2.58,1.68-3.94,2.47 c-8.36-4.86-15.06-11.01-20.23-18.12c-5.71-14.28-4.79-27.48,2.74-36.24c-9.13,20,5.86,32.56,14.17,47.9 C254.79,73.78,254.37,69.59,252.98,65.4z M223.24,26.73c-0.1-1.34-0.17-2.69-0.22-4.04c4.66-2.04,9.44-3.71,14.31-4.94 C231.12,19.6,226.23,22.45,223.24,26.73z M218.74,19.99c1.07,30.84,11.08,53.44,38.35,69.29c27.27-15.86,37.28-38.45,38.35-69.29 c-12.72-5.55-24.3-8.95-38.35-8.95C243.03,11.03,231.46,14.43,218.74,19.99z M257.09,86.86c-25.04-14.56-35.23-37.27-36.21-65.52 c11.8-5.16,23.25-8.21,36.21-8.21c12.96,0,24.41,3.07,36.21,8.21C292.32,49.59,282.13,72.3,257.09,86.86z M248.2,15.73 c4.09-0.01,8.42,1.1,11.38,3.28c-1-1.46-2.43-2.63-4.12-3.41c5.33,1.4,9.54,5.37,9.76,9.12c0.62-0.45,1.17-1.04,1.65-1.77 c-0.26,1.21-0.75,2.21-1.47,2.99c2.87,3.28,4.29,2.68,4.89,6.96c1.59,2.24,3.32,4.34,5.29,6.2c-0.72,0.42-3.28-0.93-3.48-0.33 c-0.28,0.84,1.94,1.72,2.91,2.57c-1.61,4.48-7.54,0.9-14.21,6.34c0.64-2.28,1.92-3.81,3.96-4.43c-2.36-1.83-4.22-4.17-5.43-7.15 c-0.62,1.09-0.87,2.35-0.67,3.81c-2.4-1.73-4.06-3.95-4.82-6.77c-9.8,6.54-3.8,17.52,2.6,20.8c-3.45-3.38-6.31-8.03-5.12-13.03 c3.38,14.45,21.61,12.73,21.83,30.54c11.72-13.04,17.36-30.13,18.01-48.78C277.47,16.72,263.06,14.03,248.2,15.73z M270.59,49.88 c0.16-0.7,0.13-1.43-0.16-2.21c0.14,1.55-0.58,2.7-1.71,3.64c-0.58-1.99-2.04-3.55-3.92-4.11c2.11-1.43,4.6-2.28,6.72-2.42 C272.6,46.96,271.98,48.55,270.59,49.88z M267.86,76.7c-1.31,1.16-2.68,2.27-4.11,3.34c-1.17-16.05-16.08-19.86-16.72-32.39 C249.15,59.02,265.21,59.23,267.86,76.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 270.0363,
    cy: 50.1805,
    r: 23.3621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#E50013"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#851C21"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.32,40.92c3.38,14.45,21.61,12.73,21.83,30.54c1.08-1.2,2.1-2.43,3.08-3.69 C273.84,53.16,255.41,54.1,251.32,40.92z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 266.3345,
    cy: 59.4575,
    r: 26.9387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#E50013"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#851C21"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M247.04,47.65c0.64,12.53,15.55,16.34,16.72,32.39c0.71-0.53,1.41-1.07,2.09-1.63 C263.98,61.94,248.84,60.44,247.04,47.65z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 228.718,
    cy: 57.1556,
    r: 35.8717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#E50013"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#851C21"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.61,30.07c-11.66,19.85,4,34.66,14.17,47.9C245.47,62.63,230.48,50.07,239.61,30.07z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 228.0129,
    cy: 25.5168,
    r: 21.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#E50013"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#851C21"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.82,38.23c0.41,1.99,0.88,3.94,1.43,5.87c1.86-11.06,7.84-19.06,18.74-23.38 C235.35,23.48,228.66,29.35,224.82,38.23z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 266.0325,
    cy: 55.1148,
    r: 16.2836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M253.71,45.59c4.2,7.87,19.72,9.87,22.52,22.18C274.16,55.15,260.13,54.13,253.71,45.59z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 259.1575,
    cy: 64.8876,
    r: 13.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M250.84,56c4.75,6.55,13.07,10.68,15,22.41C264.48,66.35,256,62.31,250.84,56z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 238.6124,
    cy: 54.4719,
    r: 23.3476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M237.72,33.77c-7.02,16.2,3.86,28.97,13.05,40.39C242.13,62.19,231.27,49.39,237.72,33.77z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 231.8958,
    cy: 28.9697,
    r: 17.6636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M224.82,38.23c4.25-8.52,10.84-14.47,20.16-17.51C235.35,23.48,228.66,29.35,224.82,38.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.088,
    y1: 8.6325,
    x2: 273.3209,
    y2: 40.8642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M277.03,63.07c7.72-11.54,11.3-25.16,11.98-39.02c-6.2-2.6-12.56-4.51-19.04-5.61 C281.28,26.78,284.71,40.88,277.03,63.07z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.6,53.96c-2.35,5-7.09,7.64-16.18,7.64c-6.28,0-10.84-1.37-13.79-4.27c-2.82-2.82-4.18-7.13-4.18-13.11 c0-5.38,1.28-9.52,3.84-12.38c2.99-3.24,7.64-4.91,14.35-4.91c10.33,0,14.86,3.84,16.35,8.58c0.64,1.96,0.85,4.31,0.85,5.64H30.29 c0-1.11-0.3-2.48-0.9-3.5c-0.98-1.71-2.56-2.56-5.89-2.56c-2.82,0-4.61,0.77-5.76,2.39c-1.07,1.45-1.45,3.8-1.45,6.87 c0,3.54,0.51,5.72,1.62,7.13c1.28,1.67,3.33,2.22,5.68,2.22c3.07,0,4.74-0.94,5.64-2.18c0.81-1.07,1.07-2.22,1.15-3.63h10.55 C40.84,49.27,40.67,51.91,39.6,53.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.29,43.97c0,11.87-5.68,17.68-18.1,17.68c-12.47,0-18.1-6.02-18.1-17.55c0-10.76,5.55-17.29,18.1-17.29 C74.99,26.81,80.29,32.7,80.29,43.97z M69.79,44.23c0-6.7-1.84-9.44-7.6-9.44c-5.55,0-7.51,2.65-7.51,9.44 c0,7.13,2.6,9.52,7.56,9.52C67.01,53.75,69.79,51.74,69.79,44.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.29,61.14l-11.4-18.06v18.06h-9.95V27.41h11.1l10.93,17.72V27.41h9.95v33.73H106.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.9,35.52v25.62h-10.59V35.52h-10.76v-8.11h32.19v8.11H141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.46,61.14V27.41h28.82v7.94h-18.62v4.91h17.93v8.03h-17.93v5h18.83v7.86H156.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.53,61.14V27.41h10.55v25.4h16.27v8.33H190.53z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.19,77.39c-0.45,0.66-1.28,1.09-2.58,1.09c-1.05,0-1.84-0.24-2.37-0.77c-0.54-0.53-0.82-1.36-0.82-2.58 c0-1.1,0.26-1.91,0.76-2.45c0.53-0.56,1.3-0.88,2.44-0.88c1.56,0,2.36,0.58,2.72,1.33c0.21,0.44,0.3,0.91,0.3,1.24h-1.45 c0-0.3-0.1-0.62-0.26-0.84c-0.26-0.35-0.65-0.49-1.33-0.49c-0.6,0-1,0.17-1.28,0.49c-0.3,0.33-0.41,0.88-0.41,1.63 c0,0.86,0.17,1.38,0.46,1.7c0.3,0.34,0.77,0.45,1.26,0.45c0.62,0,1-0.19,1.23-0.44c0.22-0.25,0.32-0.52,0.35-0.88h1.44 C24.63,76.33,24.57,76.84,24.19,77.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.79,72.84c0.38,0.5,0.55,1.25,0.55,2.26c0,1.06-0.21,1.8-0.58,2.35c-0.45,0.68-1.32,1.04-2.59,1.04 c-1.27,0-2.11-0.35-2.58-1.02c-0.4-0.55-0.59-1.33-0.59-2.35c0-0.96,0.17-1.71,0.56-2.22c0.49-0.67,1.29-1.1,2.61-1.1 C30.46,71.79,31.3,72.16,31.79,72.84z M30.46,76.85c0.31-0.31,0.44-1,0.44-1.71c0-0.7-0.13-1.37-0.4-1.65 c-0.28-0.3-0.62-0.5-1.33-0.5c-0.7,0-1.04,0.2-1.32,0.51c-0.26,0.29-0.4,0.96-0.4,1.65c0,0.73,0.16,1.41,0.49,1.74 c0.26,0.26,0.61,0.44,1.24,0.44C29.85,77.32,30.2,77.11,30.46,76.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.03,78.4l-2.62-4.4v4.4h-1.36v-6.5h1.65l2.5,4.19v-4.19h1.36v6.5H38.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.58,73.09v5.3h-1.45v-5.3h-2.12v-1.2h5.69v1.2H44.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.45,74.97c-0.2,0.35-0.5,0.55-0.83,0.61l1.52,2.82h-1.6l-1.27-2.53h-1.71v2.53h-1.4v-6.5h3.62 c0.83,0,1.34,0.27,1.61,0.73c0.2,0.3,0.29,0.67,0.29,1.21C53.69,74.33,53.6,74.72,53.45,74.97z M52.22,73.43 c-0.12-0.23-0.36-0.34-0.75-0.34h-1.89v1.63h1.98c0.31,0,0.56-0.09,0.65-0.27c0.06-0.12,0.09-0.34,0.09-0.5 C52.29,73.76,52.27,73.54,52.22,73.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.08,72.84c0.38,0.5,0.55,1.25,0.55,2.26c0,1.06-0.21,1.8-0.58,2.35c-0.45,0.68-1.32,1.04-2.59,1.04 c-1.27,0-2.11-0.35-2.58-1.02c-0.4-0.55-0.59-1.33-0.59-2.35c0-0.96,0.17-1.71,0.56-2.22c0.49-0.67,1.29-1.1,2.61-1.1 C59.75,71.79,60.58,72.16,61.08,72.84z M59.75,76.85c0.31-0.31,0.44-1,0.44-1.71c0-0.7-0.13-1.37-0.4-1.65 c-0.28-0.3-0.62-0.5-1.33-0.5c-0.7,0-1.04,0.2-1.32,0.51c-0.26,0.29-0.4,0.96-0.4,1.65c0,0.73,0.16,1.41,0.49,1.74 c0.26,0.26,0.61,0.44,1.24,0.44C59.14,77.32,59.49,77.11,59.75,76.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.34,78.4v-6.5h1.43v5.29h3.25v1.21H63.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.13,76.21v2.18H74.7v-2.17l-2.52-4.33h1.53l1.71,3.03l1.84-3.03h1.48L76.13,76.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.35,73.09v5.3H84.9v-5.3h-2.12v-1.2h5.69v1.2H86.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.94,78.4v-6.5h4.96v1.23h-3.57v1.41h3.44v1.23h-3.44v1.42h3.61v1.22H89.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.74,78.4v-6.5h1.43v5.29h3.25v1.21H96.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.99,78.4v-6.5h4.96v1.23h-3.57v1.41h3.44v1.23h-3.44v1.42H108v1.22H102.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.24,77.39c-0.45,0.66-1.28,1.09-2.58,1.09c-1.05,0-1.84-0.24-2.37-0.77c-0.54-0.53-0.82-1.36-0.82-2.58 c0-1.1,0.26-1.91,0.76-2.45c0.53-0.56,1.3-0.88,2.44-0.88c1.56,0,2.36,0.58,2.72,1.33c0.21,0.44,0.3,0.91,0.3,1.24h-1.45 c0-0.3-0.1-0.62-0.26-0.84c-0.26-0.35-0.65-0.49-1.33-0.49c-0.6,0-1,0.17-1.28,0.49c-0.3,0.33-0.41,0.88-0.41,1.63 c0,0.86,0.17,1.38,0.46,1.7c0.3,0.34,0.77,0.45,1.26,0.45c0.62,0,1-0.19,1.23-0.44c0.22-0.25,0.32-0.52,0.35-0.88h1.44 C115.68,76.33,115.61,76.84,115.24,77.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.84,72.84c0.38,0.5,0.55,1.25,0.55,2.26c0,1.06-0.21,1.8-0.58,2.35c-0.45,0.68-1.32,1.04-2.59,1.04 c-1.27,0-2.11-0.35-2.58-1.02c-0.4-0.55-0.59-1.33-0.59-2.35c0-0.96,0.17-1.71,0.56-2.22c0.49-0.67,1.29-1.1,2.61-1.1 C121.51,71.79,122.34,72.16,122.84,72.84z M121.51,76.85c0.31-0.31,0.44-1,0.44-1.71c0-0.7-0.13-1.37-0.4-1.65 c-0.28-0.3-0.62-0.5-1.33-0.5c-0.7,0-1.04,0.2-1.32,0.51c-0.26,0.29-0.4,0.96-0.4,1.65c0,0.73,0.16,1.41,0.49,1.74 c0.26,0.26,0.61,0.44,1.24,0.44C120.9,77.32,121.25,77.11,121.51,76.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.79,78.4v-4.3l-1.51,4.3h-1.4l-1.46-4.3v4.3h-1.33v-6.5h1.93l1.57,4.71l1.65-4.71h1.87v6.5H130.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.88,78.48c-1.62,0-2.83-0.61-2.83-2.13c0-0.15,0-4.45,0-4.45h1.42c0,0,0,4.21,0,4.33 c0,0.68,0.51,1.09,1.44,1.09c0.81,0,1.39-0.4,1.39-1.08c0-0.12,0-4.34,0-4.34h1.42c0,0,0,4.4,0,4.54 C139.72,77.8,138.54,78.48,136.88,78.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.66,78.4l-2.62-4.4v4.4h-1.36v-6.5h1.65l2.5,4.19v-4.19h1.36v6.5H145.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.22,78.4v-6.5h1.45v6.5H149.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.15,77.39c-0.45,0.66-1.28,1.09-2.58,1.09c-1.05,0-1.84-0.24-2.37-0.77c-0.54-0.53-0.82-1.36-0.82-2.58 c0-1.1,0.26-1.91,0.76-2.45c0.53-0.56,1.3-0.88,2.44-0.88c1.56,0,2.36,0.58,2.72,1.33c0.21,0.44,0.3,0.91,0.3,1.24h-1.45 c0-0.3-0.1-0.62-0.26-0.84c-0.26-0.35-0.65-0.49-1.33-0.49c-0.6,0-1,0.17-1.28,0.49c-0.3,0.33-0.41,0.88-0.41,1.63 c0,0.86,0.17,1.38,0.46,1.7c0.3,0.34,0.77,0.45,1.26,0.45c0.62,0,1-0.19,1.23-0.44c0.22-0.25,0.32-0.52,0.35-0.88h1.44 C158.6,76.33,158.53,76.84,158.15,77.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.97,78.4h-1.46l2.52-6.5h1.79l2.38,6.5h-1.48l-0.55-1.53h-2.63L160.97,78.4z M163.05,73.69l-0.15-0.54 l-0.16,0.54l-0.74,1.99h1.74L163.05,73.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.92,77.39c-0.45,0.66-1.28,1.09-2.58,1.09c-1.05,0-1.84-0.24-2.37-0.77c-0.54-0.53-0.82-1.36-0.82-2.58 c0-1.1,0.26-1.91,0.76-2.45c0.53-0.56,1.3-0.88,2.44-0.88c1.56,0,2.36,0.58,2.72,1.33c0.21,0.44,0.3,0.91,0.3,1.24h-1.45 c0-0.3-0.1-0.62-0.26-0.84c-0.26-0.35-0.65-0.49-1.33-0.49c-0.6,0-1,0.17-1.28,0.49c-0.3,0.33-0.41,0.88-0.41,1.63 c0,0.86,0.17,1.38,0.46,1.7c0.3,0.34,0.77,0.45,1.26,0.45c0.62,0,1-0.19,1.23-0.44c0.22-0.25,0.32-0.52,0.35-0.88h1.44 C173.37,76.33,173.3,76.84,172.92,77.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.05,78.4v-6.5h1.45v6.5H175.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184,72.84c0.38,0.5,0.55,1.25,0.55,2.26c0,1.06-0.21,1.8-0.58,2.35c-0.45,0.68-1.32,1.04-2.59,1.04 c-1.27,0-2.11-0.35-2.58-1.02c-0.4-0.55-0.59-1.33-0.59-2.35c0-0.96,0.17-1.71,0.56-2.22c0.49-0.67,1.29-1.1,2.61-1.1 C182.67,71.79,183.51,72.16,184,72.84z M182.67,76.85c0.31-0.31,0.44-1,0.44-1.71c0-0.7-0.13-1.37-0.4-1.65 c-0.28-0.3-0.62-0.5-1.33-0.5c-0.7,0-1.04,0.2-1.32,0.51c-0.26,0.29-0.4,0.96-0.4,1.65c0,0.73,0.16,1.41,0.49,1.74 c0.26,0.26,0.61,0.44,1.24,0.44C182.07,77.32,182.41,77.11,182.67,76.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.24,78.4l-2.62-4.4v4.4h-1.36v-6.5h1.65l2.5,4.19v-4.19h1.36v6.5H190.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.8,78.4v-6.5h4.96v1.23h-3.57v1.41h3.44v1.23h-3.44v1.42h3.61v1.22H193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.34,78.49c-1.97,0-2.68-0.59-2.94-1.42c-0.07-0.21-0.09-0.54-0.09-0.67h1.47c0,0.12,0.04,0.31,0.09,0.41 c0.18,0.38,0.61,0.54,1.47,0.54c0.99,0,1.33-0.27,1.33-0.7c0-0.54-0.27-0.72-1.33-0.92c-0.19-0.03-0.67-0.12-0.95-0.18 c-1.27-0.24-2.05-0.82-2.05-1.9c0-1.1,0.89-1.84,2.8-1.84c1.63,0,2.4,0.57,2.72,1.39c0.08,0.21,0.15,0.46,0.15,0.63h-1.47 c0-0.07-0.04-0.22-0.09-0.32c-0.17-0.36-0.53-0.55-1.35-0.55c-1.08,0-1.29,0.24-1.29,0.61c0,0.48,0.39,0.67,1.45,0.88 c0.33,0.07,0.76,0.16,0.91,0.18c1.29,0.25,1.97,0.78,1.97,1.89C206.14,77.7,205.21,78.49,203.34,78.49z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2f0ba24c376ac10acf0eba48cc497af1.svg";
export { ForwardRef as ReactComponent };